"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _StepContent = _interopRequireDefault(require("@mui/material/StepContent"));
var _excluded = ["className", "isStatic", "orientation", "disabled"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "stepContent": "wStI-v",
  "verticalConnectorsAdjusmentsStyles": "LcNkwW",
  "withMarginLeft": "_3lk6-L",
  "isStatic": "_0UnTge",
  "disabled": "MYUujM",
  "notDisabled": "-h55GH"
};
var getClassName = function getClassName(_ref) {
  var className = _ref.className,
    isStatic = _ref.isStatic,
    orientation = _ref.orientation,
    disabled = _ref.disabled;
  return (0, _clsx["default"])(className, styles.stepContent, !isStatic && orientation === 'vertical' && styles.withMarginLeft, isStatic && styles.isStatic, disabled ? styles.disabled : styles.notDisabled);
};
var StepContent = function StepContent(_ref2) {
  var className = _ref2.className,
    isStatic = _ref2.isStatic,
    orientation = _ref2.orientation,
    disabled = _ref2.disabled,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_StepContent["default"], _extends({
    className: getClassName({
      className: className,
      isStatic: isStatic,
      orientation: orientation,
      disabled: disabled
    })
  }, props));
};
StepContent.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  isStatic: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  orientation: _propTypes["default"].string
} : {};
var _default = exports["default"] = StepContent;